export const support = {
  OTHER: '#c72329',
  BASIC: '#343a40',
  MIDDLE: '#1677ff',
  ADVANCED: '#028004'
}

